"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.c = void 0;
const react_1 = __importStar(require("react"));
const basic_form_input_1 = __importDefault(require("../../../client/form_components/inputs/basic_form_input"));
const base_1 = __importDefault(require("../../../client/buttons/base"));
const custom_1 = __importDefault(require("../../../client/form_components/checkboxes/custom"));
const form_image_uploader_1 = __importDefault(require("../../../client/form_components/image_uploaders/form_image_uploader"));
const icon_1 = __importDefault(require("../../../client/icon"));
const radio_group_1 = __importDefault(require("../../../client/form_components/inputs/radio_group"));
const dispatchers_1 = require("../../../utility/dispatchers");
const Form_1 = require("./Form");
const inputs_css_1 = __importDefault(require("../../../styles/global_ui/inputs.css"));
const layout_css_1 = __importDefault(require("../../../styles/global_ui/layout.css"));
const typography_css_1 = __importDefault(require("../../../styles/global_ui/typography.css"));
const util_css_1 = __importDefault(require("../../../styles/global_ui/util.css"));
const styles_css_1 = __importDefault(require("./styles.css"));
exports.c = {
    column: `${layout_css_1.default.flexColumn} ${layout_css_1.default.gutter30}`,
    row: `${layout_css_1.default.flexJustifySpaceBetween} ${layout_css_1.default.gutter15} `,
    imageWrapper: `${styles_css_1.default.imageWrapper}`,
    shipping: `${inputs_css_1.default.label}`,
    details: `${util_css_1.default.bgFog} ${layout_css_1.default.fullWidth} ${typography_css_1.default.charcoal} ${styles_css_1.default.details}`,
    summary: `${layout_css_1.default.flexJustifySpaceBetween} ${layout_css_1.default.flexCenterItems} ${typography_css_1.default.bold} ${styles_css_1.default.summary}`,
    marker: styles_css_1.default.marker,
    content: `${layout_css_1.default.flexColumn} ${layout_css_1.default.padding15}`,
    addButton: `${layout_css_1.default.marginLeftAuto}`,
    removed: `${util_css_1.default.disabled}`,
    disabled: `${layout_css_1.default.marginBottom25} ${typography_css_1.default.error}`,
};
const Prize = ({ errors, form, giveaway, handleUpdate, prize, isSubmitting, setIsSubmitting, pendingChanges, }) => {
    const [isPrizeRemoved, setIsPrizeRemoved] = (0, react_1.useState)(false);
    const contestLaunched = giveaway.status === 'in_progress' || giveaway.status === 'completed';
    const isAddingPrize = !prize;
    const editingProhibited = contestLaunched && isAddingPrize;
    const previousPrize = giveaway?.prizes?.find((editingPrize) => editingPrize.id === prize?.id);
    const updatedPrize = form?.prizes?.find((editingPrize) => editingPrize.id === prize?.id);
    const previouslyEditedPrizes = form?.prizes?.filter((p) => p?.id !== prize?.id) || [];
    const fieldId = `prizes-${previousPrize?.id}`;
    const updateField = ({ field, value }) => {
        // disable save button while image starts upload.
        setIsSubmitting(field === 'image');
        handleUpdate({
            name: 'prizes',
            value: [
                ...previouslyEditedPrizes,
                { ...updatedPrize, id: previousPrize?.id, [field]: value },
            ],
        });
    };
    const handleDelete = () => {
        setIsPrizeRemoved(true);
        handleUpdate({
            name: 'prizes',
            value: [
                ...previouslyEditedPrizes,
                { ...updatedPrize, id: previousPrize?.id, _destroy: true },
            ],
        });
    };
    const handleImageUpload = ({ uploading }) => {
        // once status is false, we are no longer uploading
        setIsSubmitting(uploading);
    };
    (0, react_1.useEffect)(() => {
        if (Object.keys(errors).length > 0) {
            (0, dispatchers_1.summonGlobalMessenger)({
                msg: 'Check form for errors',
                type: 'error',
            });
        }
    }, [errors]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        editingProhibited && (react_1.default.createElement("div", { className: exports.c.disabled }, "Cannot add new prizes once a Giveaway has launched")),
        react_1.default.createElement("div", { className: `${layout_css_1.default.flex} ${layout_css_1.default.gutter60} ${isPrizeRemoved ? exports.c.removed : ''}` },
            react_1.default.createElement("div", { className: exports.c.imageWrapper },
                react_1.default.createElement(form_image_uploader_1.default, { allowGifs: true, allowRemoteURL: false, aspectRatio: 3 / 2, attachmentType: "Image", disabled: isSubmitting || editingProhibited, errors: errors[`${fieldId}-image`], helperText: "This image should have a ratio of 3:2 and be 651x434px (minimum 217x145px) for the best quality.", imageData: {
                        id: pendingChanges.has(`${fieldId}-image`)
                            ? updatedPrize?.image?.id
                            : previousPrize?.image?.id,
                        url: pendingChanges.has(`${fieldId}-image`)
                            ? updatedPrize?.image?.url
                            : previousPrize?.image?.url,
                    }, label: "Prize Image", propagateStatus: handleImageUpload, propagateUpload: ({ id, url }) => updateField({ field: 'image', value: { id, url } }) })),
            react_1.default.createElement("div", { className: layout_css_1.default.fullWidth },
                react_1.default.createElement(basic_form_input_1.default, { disabled: isSubmitting || editingProhibited, errors: errors[`${fieldId}-name`], label: "Name", name: "name", onChange: ({ target: { value } }) => updateField({ field: 'name', value }), placeholder: "Some Part 3000", value: pendingChanges.has(`${fieldId}-name`)
                        ? updatedPrize?.name
                        : previousPrize?.name || '' }),
                react_1.default.createElement(basic_form_input_1.default, { disabled: isSubmitting || editingProhibited, errors: errors[`${fieldId}-description`], label: "Description", name: "description", onChange: ({ target: { value } }) => updateField({ field: 'description', value }), placeholder: "This is a thing that does cool stuff", value: pendingChanges.has(`${fieldId}-description`)
                        ? updatedPrize?.description
                        : previousPrize?.description || '' }),
                react_1.default.createElement(basic_form_input_1.default, { disabled: isSubmitting || editingProhibited, errors: errors[`${fieldId}-link`], label: "URL Link (Optional)", onChange: ({ target: { value } }) => updateField({ field: 'link', value }), placeholder: "https://example.com", value: pendingChanges.has(`${fieldId}-link`)
                        ? updatedPrize?.link
                        : previousPrize?.link || '' }),
                react_1.default.createElement("div", { className: exports.c.row },
                    react_1.default.createElement(basic_form_input_1.default, { classList: { root: layout_css_1.default.fullWidth }, disabled: isSubmitting || contestLaunched, errors: errors[`${fieldId}-cash_value`], helperText: contestLaunched
                            ? 'Cannot be changed once a Giveaway has launched'
                            : '', label: "Cash Value", name: "cash_value", onChange: ({ target: { value } }) => updateField({
                            field: 'cash_value',
                            value: parseFloat(parseFloat(value).toFixed(2)),
                        }), placeholder: "500", step: ".01", type: "number", value: pendingChanges.has(`${fieldId}-cash_value`)
                            ? updatedPrize?.cash_value
                            : previousPrize?.cash_value || '' }),
                    react_1.default.createElement(basic_form_input_1.default, { classList: { root: layout_css_1.default.fullWidth }, disabled: isSubmitting || contestLaunched, errors: errors[`${fieldId}-quantity`], helperText: contestLaunched
                            ? 'Cannot be changed once a Giveaway has launched'
                            : '', label: "Quantity", name: "quantity", onChange: ({ target: { value } }) => updateField({
                            field: 'quantity',
                            value: parseInt(value),
                        }), placeholder: "5", type: "number", value: pendingChanges.has(`${fieldId}-quantity`)
                            ? updatedPrize?.quantity
                            : previousPrize?.quantity || '' })),
                react_1.default.createElement("div", { className: exports.c.row },
                    react_1.default.createElement(radio_group_1.default, { buttons: [
                            { label: 'Weekly Prize', value: 'weekly' },
                            { label: 'Grand Prize', value: 'grand' },
                        ], classList: { root: layout_css_1.default.fullWidth }, disabled: isSubmitting || contestLaunched, errors: errors[`${fieldId}-prize_type`], helperText: contestLaunched
                            ? 'Cannot be changed once a Giveaway has launched'
                            : '', label: "Prize Type", name: `prize_type-${prize?.id}`, onChange: ({ target: { value } }) => updateField({ field: 'prize_type', value }), value: pendingChanges.has(`${fieldId}-prize_type`)
                            ? updatedPrize?.prize_type
                            : previousPrize?.prize_type }),
                    react_1.default.createElement("div", { className: layout_css_1.default.fullWidth },
                        react_1.default.createElement("div", { className: exports.c.shipping }, "Shipping"),
                        react_1.default.createElement(custom_1.default, { disabled: isSubmitting || editingProhibited, isChecked: pendingChanges.has(`${fieldId}-requires_shipping`)
                                ? updatedPrize?.requires_shipping
                                : previousPrize?.requires_shipping || false, label: "Requires Shipping", name: "requires_shipping", onChange: (checked) => updateField({ field: 'requires_shipping', value: checked }) }))),
                prize?.id && (react_1.default.createElement("div", { className: (exports.c.row, layout_css_1.default.flexEndItems) },
                    contestLaunched && (react_1.default.createElement("span", { className: typography_css_1.default.bodyS }, "Cannot be removed once a Giveaway has launched")),
                    react_1.default.createElement(base_1.default, { className: layout_css_1.default.marginLeftAuto, colorStyle: "danger", disabled: isSubmitting || contestLaunched, onClick: handleDelete, size: "md" }, "Delete")))))));
};
const Prizes = ({ errors, form, giveaway, handleUpdate, isSubmitting, setIsSubmitting, pendingChanges, }) => {
    const prizes = giveaway.prizes || [];
    return (react_1.default.createElement("div", { className: Form_1.c.container },
        react_1.default.createElement("p", { className: Form_1.c.subHeader }, "Prizes"),
        react_1.default.createElement("div", { className: Form_1.c.form },
            react_1.default.createElement("div", { className: exports.c.column },
                prizes.map((prize) => (react_1.default.createElement("details", { key: prize.name, className: exports.c.details },
                    react_1.default.createElement("summary", { className: exports.c.summary },
                        prize.name,
                        react_1.default.createElement(icon_1.default, { className: exports.c.marker, name: "arrow-down", size: "16" })),
                    react_1.default.createElement("div", { className: exports.c.content },
                        react_1.default.createElement(Prize, { errors: errors, form: form, giveaway: giveaway, handleUpdate: handleUpdate, isSubmitting: isSubmitting, pendingChanges: pendingChanges, prize: prize, setIsSubmitting: setIsSubmitting }))))),
                react_1.default.createElement("details", { className: exports.c.details, open: prizes.length === 0 },
                    react_1.default.createElement("summary", { className: exports.c.summary },
                        "Add",
                        ' ',
                        prizes.length > 0 ? 'Another' : 'A',
                        ' ',
                        "Prize",
                        react_1.default.createElement(icon_1.default, { className: exports.c.marker, name: "arrow-down", size: "16" })),
                    react_1.default.createElement("div", { className: exports.c.content },
                        react_1.default.createElement(Prize, { key: "new-prize", errors: errors, form: form, giveaway: giveaway, handleUpdate: handleUpdate, isSubmitting: isSubmitting, pendingChanges: pendingChanges, setIsSubmitting: setIsSubmitting })))))));
};
exports.default = Prizes;
